export default __webpack_public_path__ + "static/chat-background-light-mode-2027c196cdc9e3c00101f3d226eded2d.png";